export const LoansLandingPageTexts = {
  OffersTitle: 'Примерные условия от банков',
  OfferSubmitButtonText: 'Продолжить',
};
